// extracted by mini-css-extract-plugin
export default {"title":"notaFiscalList_title__vKCFY","container":"notaFiscalList_container__lZ7Vb","text":"notaFiscalList_text__69Xd0"};